import { X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function SiteSmithBanner({ businessName }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div data-testid="sitesmith-banner" className="sticky top-0 z-[100] bg-[#0A0F1F] border-b border-white/[0.06] px-4 py-2.5 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <Link to="/" className="text-sm font-bold text-white shrink-0">
          Site<span className="text-slate-500 font-normal">Smith</span>
        </Link>
        <span className="text-slate-500 text-xs hidden sm:inline">This is a SiteSmith example site</span>
      </div>
      <div className="flex items-center gap-3">
        <Link to="/get-started" className="text-xs text-orange-400 hover:text-orange-300 transition-colors font-medium whitespace-nowrap" data-testid="banner-cta">
          Get a website like this for your business &rarr;
        </Link>
        <button onClick={() => setDismissed(true)} className="text-slate-600 hover:text-slate-400 transition-colors" data-testid="banner-dismiss">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
